export default __webpack_public_path__ + "static/media/standardServiceExample.81a2b00d.png";